import styled from 'styled-components';
import {
  mobile_width_percentage,
  sm_mobile_breakpoint,
  lg_mobile_breakpoint,
  tablet_portrait_breakpoint,
  desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors.js';

export const FeatureCardStyles = styled.section`
  margin: 57px auto;
  width: ${mobile_width_percentage}%;

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    width: ${mobile_width_percentage}%;
    max-width: 1100px;
  }

  h5 {
    font-family: 'source-sans-pro', Helvetica, Arial, sans-serif;
  }

  .card-grid {
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto;

    .card-grid-picture {
      grid-area: 1 / 1;
      align-self: center;

      h3 {
        font-size: 22px;
        line-height: 26px;
        letter-spacing: -0.35px;
        padding-bottom: 18px;
      }
      @media screen and (min-width: ${lg_mobile_breakpoint}px) {
        h3 {
          font-size: 25px;
          line-height: 30px;
        }
      }

      img {
        object-fit: cover;
      }

      > a {
        text-decoration: none;
      }
    }

    .feature-image-wrapper {
      position: relative;

      img {
        width: 100%;
        height: auto;
      }
    }

    .card-grid-detail {
      grid-area: 2 / 1;
      align-self: center;

      h3 {
        display: none;
      }

      > a {
        text-decoration: none;
      }

      .card-desc {
        padding-top: 27px;
        padding-bottom: 20px;
        font-family: 'source-sans-pro', Helvetica, Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 27px;
        color: black;
        .markdown {
          p {
            color: inherit;
            word-wrap: break-word;
            a {
              color: ${Colors.primary.claytonBlue.standard};
            }
          }
        }
      }

      .card-link a {
        display: flex;
        @media only screen and (min-width: ${sm_mobile_breakpoint}px) {
          width: auto;
        }
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: left;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: -0.3px;
        text-decoration: none;

        h5 {
          color: ${Colors.primary.claytonBlue.standard};
        }

        .link-arrow {
          transition: 0.5s;
          svg {
            pointer-events: none;
            margin-left: 5px;
            margin-top: 3px;
            * {
              fill: ${Colors.primary.claytonBlue.standard};
            }
          }
        }
        :hover {
          transition-timing-function: ease-in;
          .link-arrow {
            transform: translateX(30%);
          }
        }
      }
    }
  }

  @media screen and (min-width: ${tablet_portrait_breakpoint}px) {
    .card-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto;
      grid-column-gap: 8%;

      .card-grid-picture {
        grid-area: 1 /
          ${(props) => (props.imagePlacement === 'left' ? '1' : '2')};
        align-self: center;

        h3 {
          display: none;
        }
      }

      .card-grid-detail {
        grid-area: 1 /
          ${(props) => (props.imagePlacement === 'left' ? '2' : '1')};
        align-self: center;

        h3 {
          display: inline;
        }
        .card-desc {
          padding-top: 27px;
        }
      }
    }
  }
`;
